import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../_models/user-name-display-result-dto';

export class WorkFlowWorkOrderResultDto {
    workOrderId: number;
    location: string;
    communityId: number;
    communityCode: string;
    community: string;
    status: string;
    priority: string;
    vendor: string;
    vendorId: number;
    vendorCode: string;
    customerId: string;
    referenceType: string;
    reference: string;

    @Type(() => Date)
    createDate: Date;

    @Type(() => UserNameDisplayResultDto)
    responsible: UserNameDisplayResultDto;
    @Type(() => UserNameDisplayResultDto)
    createdBy: UserNameDisplayResultDto;

    @Type(() => Date)
    dueDate: Date;
    authorizationAmount: number;
    taskIds: Array<number>;
    invoiceIds: Array<number>;
    vendorEstimate: number;
    attachmentCount: number;
    jobType: string;
    description: string;

    @Type(() => UserNameDisplayResultDto)
    dashboardResponsible: Array<UserNameDisplayResultDto>;

    caller: string;
    ownerName: string;
    ownerPhone: string;

    @Type(() => UserNameDisplayResultDto)
    primaryAcam: Array<UserNameDisplayResultDto>;
    @Type(() => UserNameDisplayResultDto)
    primaryCam: Array<UserNameDisplayResultDto>;

    @Type(() => Date)
    statusChanged: Date;

    @Type(() => UserNameDisplayResultDto)
    statusChangedBy: UserNameDisplayResultDto;

    dashboardPriority: boolean;

    dashboardProblematic: boolean;

    hasNotes: boolean;
    maintenanceJob: number;
    workOrderVendorId: number;
    workAuthorizationFileStoreId: number;
    workAuthorizationFileName: string;
    allowGenerateWorkAuthorization: boolean;
    allowGenerateAndEmailWorkAuthorization: boolean;
    allowEmailLatestWorkAuthorization: boolean;
    allowAction: boolean;
    allowChangeStatus: boolean;
    allowManageInvoiceReferences: boolean;
    allowCreateMaintenanceJob: boolean;
    allowViewMaintenanceJob: boolean;

    get responsibleUserDisplayText(): string {
        return Utils.notNullAndDefined(this.responsible) ? this.responsible.displayName : '';
    }

    get createdByUserDisplayText(): string {
        return Utils.notNullAndDefined(this.createdBy) ? this.createdBy.displayName : '';
    }

    get dashboardResponsibleUserDisplayText(): string {
        return Utils.notNullOrEmpty(this.dashboardResponsible)
            ? this.dashboardResponsible.map((r) => r.displayName).join(', ')
            : '';
    }

    get primaryAcamDisplayText(): string {
        return Utils.notNullOrEmpty(this.primaryAcam) ? this.primaryAcam.map((r) => r.displayName).join(', ') : '';
    }

    get primaryCamDisplayText(): string {
        return Utils.notNullOrEmpty(this.primaryCam) ? this.primaryCam.map((r) => r.displayName).join(', ') : '';
    }

    get statusChangedByDisplayText(): string {
        return Utils.notNullAndDefined(this.statusChangedBy) ? this.statusChangedBy.displayName : '';
    }

    get invoiceIdText(): string {
        return Utils.notNullOrEmpty(this.invoiceIds) ? this.invoiceIds.join(', ') : '';
    }

    get taskIdText(): string {
        return Utils.notNullOrEmpty(this.taskIds) ? this.taskIds.join(', ') : '';
    }

    get dashboardStatusDisplayText(): string {
        let dashboardStatus: string = null;
        if (Utils.isTrue(this.dashboardProblematic)) {
            dashboardStatus = 'Problematic';
        } else if (Utils.isTrue(this.dashboardPriority)) {
            dashboardStatus = 'Priority';
        }
        return dashboardStatus;
    }
}
